import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { FormGroup, Button, Intent, TextArea } from "@blueprintjs/core";
import { observable } from 'mobx';
import Toast from 'helpers/toaster';
import FormDrawer from 'components/FormDrawer';
import { FormSection, FieldError, MoreOptions } from 'components/FormBits';

const isBlank = (value) => value === undefined || value === null || String(value).trim() === '';

// Bring a field with an error into view and put the cursor in it.
const focusField = (id) => {
  setTimeout(() => {
    const field = document.getElementById(id);
    if (!field) return;
    field.scrollIntoView({ block: 'center', behavior: 'smooth' });
    field.focus({ preventScroll: true });
  }, 0);
};

@inject('productCategoryStore', 'quickbooksStore') @observer
class ProductCategory extends Component {
  @observable error = null;

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.error = null;
    }
  }

  // The title is required: say so under the field and put the cursor there.
  validate(object) {
    if (isBlank(object.title)) {
      this.error = 'Enter a title, e.g. Filters.';
      focusField('product-category-title');
      return false;
    }
    this.error = null;
    return true;
  }

  componentDidMount() {
    //this.props.quickbooksStore.loadQuickbooksItems()
  }

  handleCloseDailog() {
    // clearing object
    this.props.productCategoryStore.productCategory.object = {}
    this.props.onClose()
  }

  createProductCategory() {
    let { 
      productCategoryStore,
      productCategoryStore:{
        productCategory: {
          object
        }
      }
     } = this.props;

    if (!this.validate(object)) {
      return;
    }
    productCategoryStore.create()
      .then(this.onSuccessfullyCreateProductCategory.bind(this))
      .catch(this.onFailCreateProductCategory.bind(this))
  }

  onSuccessfullyCreateProductCategory(response) {
    this.props.productCategoryStore.productCategory.object = {} // so the next Add starts blank
    this.props.onSuccess()
    Toast.show({ message: "Product category created successfully.", intent: Intent.SUCCESS })
  }

  onFailCreateProductCategory(error) {
    if(error.response && error.response.data && error.response.data.errors) {
      Toast.show({ message: error.response.data.errors, intent: Intent.DANGER })
    } else {
      Toast.show({ message: "Something went wrong. Failed to create/update product category.", intent: Intent.DANGER })
    }
  }

  updateProductCategory() {
    let { 
      productCategoryStore,
      productCategoryStore:{
        productCategory: {
          object
        }
      }
     } = this.props;
     
    if (!this.validate(object)) {
      return;
    }
    productCategoryStore.update()
      .then(this.onSuccessfullyUpdateProductCategory.bind(this))
      .catch(this.onFailCreateProductCategory.bind(this))
  }

  onSuccessfullyUpdateProductCategory(response) {
    this.props.productCategoryStore.productCategory.object = {} // so the next Add starts blank
    this.props.onSuccess()
    Toast.show({ message: "Product category updated successfully.", intent: Intent.SUCCESS })
  }

  render() {
    let {
      edit,
      productCategoryStore: {
        productCategory: {
          isLoading,
          object
        }
      }
    } = this.props;
    const busy = !!isLoading;
    const close = this.handleCloseDailog.bind(this);

    return(
      <FormDrawer
        title={edit ? "Edit product category" : "New product category"}
        icon={edit ? "edit" : "folder-close"}
        isOpen={this.props.isOpen}
        onClose={close}
        busy={busy}
        footer={
          <>
            <Button text="Cancel" onClick={close} disabled={busy} />
            {edit ?
              <Button
                intent={Intent.PRIMARY}
                icon="floppy-disk"
                text="Save changes"
                loading={busy}
                onClick={this.updateProductCategory.bind(this)}
              />
              :
              <Button
                intent={Intent.PRIMARY}
                icon="add"
                text="Create product category"
                loading={busy}
                onClick={this.createProductCategory.bind(this)}
              />
            }
          </>
        }
      >
        <FormSection title="Category" hint="Groups products and services in your price book.">
          <FormGroup
            className={this.error ? 'has-error' : undefined}
            label="Title"
            labelFor="product-category-title"
            labelInfo="*"
          >
            <input
              id="product-category-title"
              type='text'
              className='bp3-input bp3-fill'
              placeholder='e.g. Filters'
              defaultValue={object.title}
              aria-invalid={!!this.error}
              onChange={(event) => { object.title = event.target.value; this.error = null; } }
            />
            <FieldError>{this.error}</FieldError>
          </FormGroup>
          <MoreOptions label="Add a description" open={!isBlank(object.description)}>
            <FormGroup label="Description" labelFor="product-category-description">
              <TextArea
                id="product-category-description"
                fill={true}
                placeholder="e.g. Air filters for furnaces and air handlers"
                defaultValue={object.description}
                onChange={(event) => { object.description = event.target.value } }
              />
            </FormGroup>
          </MoreOptions>
        </FormSection>
      </FormDrawer>
    )
  }

}

export default ProductCategory;